import React from 'react';

export default function Card({ children, className = '', onClick, hover, ...props }) {
  return (
    <div
      onClick={onClick}
      className={`sp-panel ${hover ? 'cursor-pointer' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
